module.exports = __webpack_public_path__ + "img/Availability.dd25bf3e.svg";